/**
 * 将资源库绝对地址改写为同源相对路径，走 Nitro `/content/**` 代理。
 * 后端常下发 http://localhost:8815/content/...，浏览器直连会 ERR_CONNECTION_REFUSED。
 */
export function toSameOriginAssetUrl(url: string): string {
  const src = url.trim()
  if (!src) return src

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    const u = new URL(src, base)
    if (u.pathname.startsWith('/content/')) {
      return `${u.pathname}${u.search}${u.hash}`
    }
  } catch {
    // ignore
  }
  return src
}
